import React, { useEffect, useState } from 'react';
import { Card, CardContent, Typography, ButtonBase } from '@material-ui/core';
import { useNavigate } from 'react-router-dom';

import { deriveHotspotNames, fetchHotspotSpeciesMeta } from '../../../lib/hotspotTaxonomy';

const Hotspot = ({ hotspotInfo }) => {
    const history = useNavigate();
    const [speciesMeta, setSpeciesMeta] = useState(null);
    const hotspotId = hotspotInfo._id || hotspotInfo.item_type_id || hotspotInfo.id;
    const hotspotLabel = hotspotInfo.h3_location || hotspotInfo.h3 || hotspotInfo.item_type_id || 'Unnamed hotspot';
    const observationCount = hotspotInfo.observations_count ?? hotspotInfo.count ?? hotspotInfo.hotspot_count ?? 0;
    const individualCount = hotspotInfo.individuals_count ?? hotspotInfo.individual_count ?? 0;
    const openHotspot = () => history(`/hotspots/${hotspotId}`);
    const { primaryName, secondaryName, commonName, scientificName } = deriveHotspotNames(
        hotspotInfo,
        speciesMeta
    );

    useEffect(() => {
        let active = true;
        if (!hotspotInfo.taxonKey) {
            setSpeciesMeta(null);
            return () => {
                active = false;
            };
        }

        fetchHotspotSpeciesMeta(hotspotInfo.taxonKey).then((meta) => {
            if (!active) return;
            setSpeciesMeta(meta);
        });

        return () => {
            active = false;
        };
    }, [hotspotInfo.taxonKey]);

    return (
        <Card raised elevation={6} className="atlas-result-card">
            <ButtonBase onClick={openHotspot} className="atlas-card-button">
                <CardContent className="atlas-card-content">
                    <span className="atlas-card-kicker">Hotspot</span>
                    <Typography variant="h5" component="h2" className="atlas-card-title">
                        {hotspotLabel}
                    </Typography>
                    <Typography variant="body2" className="atlas-card-copy">
                        Dense activity cluster with a strong observation count and a direct path
                        into the underlying cell.
                    </Typography>
                    <div className="atlas-detail-list">
                        <span>
                            <strong>Common name</strong>
                            {commonName}
                        </span>
                        <span>
                            <strong>Scientific name</strong>
                            {scientificName}
                        </span>
                    </div>
                    <div className="atlas-metric-row atlas-metric-row--triple">
                        <div>
                            <strong>{Number(observationCount).toLocaleString()}</strong>
                            <span>observations</span>
                        </div>
                        <div>
                            <strong>{primaryName}</strong>
                            <span>{secondaryName || 'species focus'}</span>
                        </div>
                        <div>
                            <strong>{Number(individualCount).toLocaleString()}</strong>
                            <span>individuals</span>
                        </div>
                    </div>
                    <span className="atlas-card-link">Open hotspot</span>
                </CardContent>
            </ButtonBase>
        </Card>
    );
};

export default Hotspot;
